import React from 'react'
import './styles/LoadingProgress.css'

export default function LoadingProgress() {
  return (
    <div className="loader-container">
      <div className="load" id="load-25"></div>
    </div>
  )
}
